import TabPanel from './TabPanel';

export { type TabPanelProps } from './TabPanel';
export default TabPanel;
